import { TAGLink, resolvePhoneNumberFormat } from '@aspendental/shared-components-web';
import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { contactNumber } from '@src/constants';

const FurtherAssistanceContact = () => {
	const { t } = useTranslation('index');

	return (
		<>
			<Typography variant="bodySmallBook" sx={{ paddingRight: 0.5 }}>
				{t('furtherAssistance')}
			</Typography>
			<TAGLink
				href={`tel:+1${contactNumber}`}
				linkSx={{
					textDecoration: 'none',
					'&:hover': {
						textDecoration: 'underline',
					},
				}}
			>
				<Typography color="text.interactive" variant="bodySmallBook">
					{resolvePhoneNumberFormat(contactNumber)}
				</Typography>
			</TAGLink>
		</>
	);
};

export default FurtherAssistanceContact;
